import React, { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../i18n";

const to12 = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };
const slotsOf = (g) => {
  const out = []; if (!g?.draw_time) return out;
  const step = g.interval_minutes || 30; const [h0, m0] = g.draw_time.split(":").map(Number); const [h1, m1] = (g.last_draw_time || g.draw_time).split(":").map(Number);
  for (let t = h0 * 60 + m0; t <= h1 * 60 + m1; t += step) out.push(`${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`);
  const off = new Set(g.disabled_slots || []);
  return out.filter((t) => !off.has(t));
};

/* Today's interval-show (Lucky) results as one compact slot grid: done → number, next → pulsing, later → dim. */
export function LuckyToday({ game, date }) {
  const { lang } = useI18n();
  const [rows, setRows] = useState([]);
  const [day, setDay] = useState(date || "");
  useEffect(() => {
    if (!game) return;
    const d = date || new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);
    setDay(d);
    const load = () => api.get("/results", { params: { game_id: game.id, date: d, limit: 200 } }).then((r) => setRows(r.data)).catch(() => {});
    load(); const t = setInterval(load, 30000); return () => clearInterval(t);
  }, [game, date]);
  if (!game) return null;
  const byTime = Object.fromEntries(rows.map((r) => [r.draw_time, r]));
  const slots = slotsOf(game);
  const nextSlot = slots.find((s) => !byTime[s]);
  const done = slots.filter((s) => byTime[s]).length;
  return (
    <div className="rl-card overflow-hidden" data-testid="lucky-today">
      <div className="px-3.5 py-2.5 bg-slate-900 text-white flex items-center justify-between">
        <div className="font-display font-bold text-sm flex items-center gap-1"><Zap className="w-4 h-4 text-amber-300" />{game.name} · {lang === "ta" ? "இன்று" : "today"}</div>
        <div className="text-[10px] text-slate-300" data-testid="lucky-today-progress">{done}/{slots.length} {lang === "ta" ? "முடிந்தது" : "drawn"}{nextSlot ? ` · ${lang === "ta" ? "அடுத்து" : "next"} ${to12(nextSlot)}` : ""}</div>
      </div>
      <div className="grid grid-cols-4 gap-1.5 p-2.5" data-testid="lucky-today-grid">
        {slots.map((s) => {
          const r = byTime[s];
          const isNext = s === nextSlot;
          return (
            <div key={s} className={`rounded-xl px-1 py-1.5 text-center border ${r ? "bg-amber-50 border-amber-200" : isNext ? "bg-blue-50 border-blue-300 animate-pulse" : "bg-slate-50 border-slate-100"}`} data-testid={`lucky-slot-${s.replace(":", "")}`}>
              <div className={`text-[9px] font-bold ${r ? "text-amber-800" : isNext ? "text-blue-700" : "text-slate-400"}`}>{to12(s)}</div>
              <div className={`font-mono font-black text-sm tracking-widest ${r ? "text-slate-900" : isNext ? "text-blue-600" : "text-slate-300"}`}>{r ? r.winning_number : isNext ? "···" : "—"}</div>
            </div>
          );
        })}
      </div>
      <div className="px-3 pb-2 text-[10px] text-slate-500">{day}</div>
    </div>
  );
}
